import { render, staticRenderFns } from "./VisitorTaskListView.vue?vue&type=template&id=0ff20d3e"
import script from "./VisitorTaskListView.vue?vue&type=script&lang=js"
export * from "./VisitorTaskListView.vue?vue&type=script&lang=js"
import style0 from "./VisitorTaskListView.vue?vue&type=style&index=0&id=0ff20d3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports